import { ProLightXmark } from '@nexelem/icons/ProLightXmark';
import { IconButton } from '@nexelem/components';
import { SelectResource } from './SelectResource';
import { ResourceGroup } from '@nexelem/graphne-api';
import { closeBrigadeDrawer } from './BrigadeDrawer';
import { AutoAssignmentButton } from '../AutoAssignmentModal';

export type HeaderProps = {
  areas: ResourceGroup[];
  areaId: number;
  setAreaId: (id: number) => void;
};

export const DrawerHeader = ({ areas, setAreaId, areaId }: HeaderProps) => {
  const area = areas.find((area) => area.id === areaId);

  return (
    <div className="flex items-center justify-between border-b border-border-primary py-4 pr-2 pl-6">
      <div className="flex items-center gap-2">
        {/* // TODO: NEX-1853 Add dot when color available */}
        {/* <div className="mr-2 h-4 w-4 rounded-full" style={{ backgroundColor: area?. }} /> */}
        <span className="text-t24-sb">{area?.name}</span>
      </div>
      <div className="flex items-center">
        <AutoAssignmentButton />
        <SelectResource areas={areas} onSelect={setAreaId} />
        <IconButton Icon={ProLightXmark} onClick={closeBrigadeDrawer} />
      </div>
    </div>
  );
};
